import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentView,
  setMiraFTE,
  setFrankFTE,
  setOrganizationName,
  setSelectedOption,
  setSelectedOrgId,
  setOrgSearchResults,
  setIsSearchingOrgs,
  setShowOrgSuggestions,
  setEmail,
  setEmailError,
  setIsEmailValid,
  setOfficeNumber,
  setProviderSearchResults,
  setIsSearchingProviders,
  setShowProviderSuggestions,
  setSelectedProvider,
  setCartCapabilities,
  toggleCartCapability,
  setTaxRate,
  resetSignupData,
} from '../slices/signupSlice';
import {
  selectCurrentView,
  selectMiraFTE,
  selectFrankFTE,
  selectOrganizationName,
  selectSelectedOption,
  selectEmail,
  selectOfficeNumber,
  selectEmailError,
  selectIsEmailValid,
  selectOrgSearchResults,
  selectIsSearchingOrgs,
  selectShowOrgSuggestions,
  selectSelectedOrgId,
  selectProviderSearchResults,
  selectIsSearchingProviders,
  selectShowProviderSuggestions,
  selectSelectedProvider,
  selectCartCapabilities,
  selectTaxRate,
  selectCartDetails,
  selectSignupData,
} from '../slices/signupSlice';

export const useSignup = () => {
  const dispatch = useDispatch();

  // Selectors
  const currentView = useSelector(selectCurrentView);
  const miraFTE = useSelector(selectMiraFTE);
  const frankFTE = useSelector(selectFrankFTE);
  const organizationName = useSelector(selectOrganizationName);
  const selectedOption = useSelector(selectSelectedOption);
  const email = useSelector(selectEmail);
  const officeNumber = useSelector(selectOfficeNumber);
  const emailError = useSelector(selectEmailError);
  const isEmailValid = useSelector(selectIsEmailValid);
  const orgSearchResults = useSelector(selectOrgSearchResults);
  const isSearchingOrgs = useSelector(selectIsSearchingOrgs);
  const showOrgSuggestions = useSelector(selectShowOrgSuggestions);
  const selectedOrgId = useSelector(selectSelectedOrgId);
  const providerSearchResults = useSelector(selectProviderSearchResults);
  const isSearchingProviders = useSelector(selectIsSearchingProviders);
  const showProviderSuggestions = useSelector(selectShowProviderSuggestions);
  const selectedProvider = useSelector(selectSelectedProvider);
  const cartCapabilities = useSelector(selectCartCapabilities);
  const taxRate = useSelector(selectTaxRate);
  const cartDetails = useSelector(selectCartDetails);
  const signupData = useSelector(selectSignupData);

  // Action dispatchers
  const updateCurrentView = (view) => dispatch(setCurrentView(view));
  const updateMiraFTE = (fte) => dispatch(setMiraFTE(fte));
  const updateFrankFTE = (fte) => dispatch(setFrankFTE(fte));
  const updateOrganizationName = (name) => dispatch(setOrganizationName(name));
  const updateSelectedOption = (option) => dispatch(setSelectedOption(option));
  const updateSelectedOrgId = (orgId) => dispatch(setSelectedOrgId(orgId));
  const updateOrgSearchResults = (results) => dispatch(setOrgSearchResults(results));
  const updateIsSearchingOrgs = (searching) => dispatch(setIsSearchingOrgs(searching));
  const updateShowOrgSuggestions = (show) => dispatch(setShowOrgSuggestions(show));
  const updateEmail = (email) => dispatch(setEmail(email));
  const updateEmailError = (error) => dispatch(setEmailError(error));
  const updateIsEmailValid = (valid) => dispatch(setIsEmailValid(valid));
  const updateOfficeNumber = (number) => dispatch(setOfficeNumber(number));
  const updateProviderSearchResults = (results) => dispatch(setProviderSearchResults(results));
  const updateIsSearchingProviders = (searching) => dispatch(setIsSearchingProviders(searching));
  const updateShowProviderSuggestions = (show) => dispatch(setShowProviderSuggestions(show));
  const updateSelectedProvider = (provider) => dispatch(setSelectedProvider(provider));
  const updateCartCapabilities = (caps) => dispatch(setCartCapabilities(caps));
  const updateToggleCartCapability = (capId) => dispatch(toggleCartCapability(capId));
  const updateTaxRate = (rate) => dispatch(setTaxRate(rate));
  const resetData = () => dispatch(resetSignupData());

  return {
    // State
    currentView,
    miraFTE,
    frankFTE,
    organizationName,
    selectedOption,
    email,
    officeNumber,
    emailError,
    isEmailValid,
    orgSearchResults,
    isSearchingOrgs,
    showOrgSuggestions,
    selectedOrgId,
    providerSearchResults,
    isSearchingProviders,
    showProviderSuggestions,
    selectedProvider,
    cartCapabilities,
    taxRate,
    cartDetails,
    signupData,

    // Actions
    updateCurrentView,
    updateMiraFTE,
    updateFrankFTE,
    updateOrganizationName,
    updateSelectedOption,
    updateSelectedOrgId,
    updateOrgSearchResults,
    updateIsSearchingOrgs,
    updateShowOrgSuggestions,
    updateEmail,
    updateEmailError,
    updateIsEmailValid,
    updateOfficeNumber,
    updateProviderSearchResults,
    updateIsSearchingProviders,
    updateShowProviderSuggestions,
    updateSelectedProvider,
    updateCartCapabilities,
    updateToggleCartCapability,
    updateTaxRate,
    resetData,
  };
};

export default useSignup;
